
import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Checkbox } from "@/components/ui/checkbox";

interface AdvancedSectionProps {
  progressState: string;
  category: string;
  archived: boolean;
  onProgressStateChange: (state: string) => void;
  onCategoryChange: (category: string) => void;
  onArchivedChange: (archived: boolean) => void;
}

export const AdvancedSection = ({
  progressState,
  category,
  archived,
  onProgressStateChange,
  onCategoryChange,
  onArchivedChange,
}: AdvancedSectionProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium">Progress State</label>
        <Select value={progressState} onValueChange={onProgressStateChange}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_started">Not Started</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="review">Review</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium">Category</label>
        <Input
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
          placeholder="Enter category"
        />
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="archived"
          checked={archived}
          onCheckedChange={(checked) => onArchivedChange(!!checked)}
        />
        <label htmlFor="archived" className="text-sm font-medium">
          Archived
        </label>
      </div>
    </div>
  );
};
